import {
  OuiDialogComponent,
  OuiIconButtonComponent,
  OuiRowComponent,
  OuiStackComponent,
  OuiTextComponent,
} from '@aiz-gl/omni-ui';
import { Component, effect, input, signal } from '@angular/core';

@Component({
  selector: 'app-validation-errors-dialog',
  imports: [
    OuiDialogComponent,
    OuiTextComponent,
    OuiStackComponent,
    OuiRowComponent,
    OuiIconButtonComponent,
  ],
  templateUrl: './validation-errors-dialog.component.html',
})
export class ValidationErrorsDialogComponent {
  errors = input<string[]>();
  dialogTitle = input.required<string>();
  protected readonly showDialog = signal<boolean>(false);

  constructor() {
    effect(() => {
      if (this.errors()?.length) {
        this.showDialog.set(true);
      }
    });
  }
}
